import styled from 'styled-components';
import { H2 } from '../../../styles/FontStyles';

import fistHubBackground from '../../../assets/images/backoffice/akasha/ahashaFistHubBackground.png';
import fistHubBackgroundMobile from '../../../assets/images/backoffice/akasha/ahashaFistHubBackgroundMobile.png';

import { Box } from '../../../styles/GlobalComponents';

export const AkashaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  /* margin: 0 140px; */
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    margin: 0;
  }
`;

export const AdvantagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  /* margin: 0 140px; */
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    margin: 0;
  }
`;

export const GridItem = styled(Box)<{
  selected: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.neutral900};
  border-radius: 30px;
  padding: 10px;
  text-align: center;
  > div {
    padding: 0 20px;
  }
  /* ${({ selected, theme }) =>
    selected &&
    `
      background-color: ${theme.colors.secondaryBlue};
    `} */
  margin-bottom: 0;

  @media (max-width: 1000px) {
    width: 100%;
  }
`;
